// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"1f8114bd","193":"74372268","243":"db961e50","288":"9d5afd70","393":"57db38b8","701":"bda34858","745":"12a1e974","911":"5a2c2f5c","988":"65d8ad4a"}[chunkId] + ".chunk.js";
};